import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { ThemingService } from '@michelin/theme';
import * as moment from 'moment';
import { UserState } from '../../../shared/state/UserState';

import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import _ from 'lodash-es';
import { FeatureflagsService } from '../../../shared/services/featureflags.service';
import { FEATURE_FLAGS } from '../../../shared/constants/constants';
import { TranslationService } from '../../../shared/translations/services/translation.service';
import { Router, NavigationEnd } from '@angular/router';
import { TranslationState } from '../../../shared/state/TranslationState';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { UtilityService } from '../../../shared/services/utility.service';
import { DealerDataService } from '../../../features/setup-screens/services/dealer-data.service';
import { DealerState } from '../../../shared/state/DealerState';

const darkClassName = 'dark-mode';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false
})
export class LayoutComponent implements OnInit {
  public themingService = inject(ThemingService);
  @HostBinding('class') public className = this.themingService.theme.className;
  public store = inject(Store);
  public featureflagsService = inject(FeatureflagsService);
  public translationService = inject(TranslationService);
  public router = inject(Router);
  public utilityService = inject(UtilityService);
  public dealerDataService = inject(DealerDataService);

  year = moment.utc().format('YYYY');
  version = environment.version;
  darkMode = this.className === darkClassName;
  firstName: string;
  lastName: string;
  profileName: string;
  isUserMgmtEnabled = false;
  isTranslationsLoading$: Observable<boolean>;
  zoneImageUrl$: Observable<string | null>;
  isChangePasswordPage = false;
  position = this.utilityService.sharedData;
  reportUrl: string = '';

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.isChangePasswordPage = event.url.includes('/changepassword');
    });
  }

  /**
   * Toggle theme
   * Light or dark
   */
  ngOnInit() {
    this.isTranslationsLoading$ = this.store.select(TranslationState.loading);
    this.zoneImageUrl$ = this.store.select(DealerState.zoneImageUrl);
    this.firstName = this.store.selectSnapshot(UserState.getFirstName);
    this.lastName = this.store.selectSnapshot(UserState.getLastName);
    this.profileName = _.head(this.firstName) + _.head(this.lastName);
    this.isUserMgmtEnabled = this.featureflagsService.getFeatureFlagValue(FEATURE_FLAGS.USER_MGMT_ENABLED);
    this.dealerDataService.getDealerSetup().subscribe({
      next: (response) => {
        if (response?.data?.reportUrl) {
          this.reportUrl = response.data.reportUrl;
        }
      }
    });
  }

  setTheme() {
    this.darkMode = !this.darkMode;
    this.className = this.themingService.display(this.darkMode ? darkClassName : '', this.darkMode);
  }

  navigateToChangePassword() {
    this.router.navigateByUrl('/home/changepassword');
  }
}
